import { Dropdown, Space } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DownOutlined, SmileOutlined } from "@ant-design/icons";

const MobileHamburger = ({ items , menu2 }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSlowmoActive, setIsSlowmoActive] = useState(false);

  useEffect(() => {
    const handleMenuToggle = () => {
      setIsMenuOpen((prev) => !prev);
    };

    const handleSlowmoToggle = () => {
      setIsSlowmoActive((prev) => !prev);
    };

    const burger = document.getElementById("menu-toggle");
    const nav = document.getElementById("custom-main-nav");
    const slowmo = document.getElementById("slowmo-toggle");

    if (burger) {
      burger.addEventListener("click", handleMenuToggle);
    }

    if (slowmo) {
      slowmo.addEventListener("click", handleSlowmoToggle);
    }

    return () => {
      if (burger) {
        burger.removeEventListener("click", handleMenuToggle);
      }

      if (slowmo) {
        slowmo.removeEventListener("click", handleSlowmoToggle);
      }
    };
  }, []);

  return (
    <div className="show-mobile">
      <div className="custom-device">
        <div className="custom-container">
          <button
            id="menu-toggle"
            className={isMenuOpen ? "open-main-nav is-open" : "open-main-nav"}
          >
            <span className="menu-icon"></span>
            {/* <span className="menu-text">Menu</span> */}
          </button>
          <nav
            className={
              isMenuOpen ? "custom-main-nav is-open" : "custom-main-nav"
            }
            id="custom-main-nav"
          >
            {/* <Dropdown
              menu={{
                items,
              }}
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  Product
                  <DownOutlined />
                </Space>
              </a>
            </Dropdown> */}
            {/* <a
              target="blank"
              style={{ marginRight: "15px" }}
              href={"https://help.telemit.com/"}
            >
              <b className="my-lbutton-10">Guide</b>
            </a>

            <Dropdown overlay={menu2}>
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <Space>
                  Use Cases <DownOutlined />
                </Space>
              </a>
            </Dropdown> */}
            <Link to={"/pricing"}>
              <b className="my-lbutton-10">Pricing</b>
            </Link>
            <a
              target="blank"
              style={{ margin: "15px" }}
              href={"https://help.telemit.com/company"}
            >
              <b className="my-lbutton-10">Company</b>
            </a>

            <a
              style={{ margin: "15px" }}
              href="https://calendly.com/paulw-zhrz/30min"
              target="blank"
            >
              <button className="my-lbutton">Request Access</button>
            </a>

            <a href={"https://app.telemit.com"}>
              <button className="my-lbutton">Login</button>
            </a>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default MobileHamburger;
